import * as React from 'react';
import styled from 'styled-components';

type Props = {
  value: string;
  variant?: string;
};

const Text = styled.h2({
  opacity: 0.9,
  fontWeight: 500,
  fontSize: '18px',
  letterSpacing: '.19px',
  lineHeight: '22px',
  textAlign: 'center',

  '@media screen and (min-width: 768px)': {
    fontSize: '20px',
    letterSpacing: '.21px',
    lineHeight: '24px',
  },
});

const Header: React.FC<Props> = ({ value }) => {
  // @ts-ignore (it doesn't like passing "as" as a variable instead of string)
  return <Text>{value}</Text>;
};

export default Header;
